var _style, _rect, _text, _g, _circle, _path, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408 320.3",
    style: {
      enableBackground: "new 0 0 408 320.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{font-family:'ArialMT';}\r\n\t.st3{font-size:18px;}\r\n\t.st4{font-size:16px;}\r\n\t.st5{fill:url(#SVGID_1_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10.2,
    className: "st0",
    width: 300,
    height: 200
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 53.728 117.8801)",
    className: "st1 st2 st3"
  }, "NodeSize by log2FC (TNBC/non-TNBC)")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 123.208 148.9096)",
    className: "st1 st2 st4"
  }, "Min Size: Not significant"), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.7,
    cy: 174.9,
    r: 15
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 123.208 179.0464)",
    className: "st1 st2 st4"
  }, "pvalue &lt; 0.05, log2FC = 0.8"), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.7,
    cy: 248.6,
    r: 50
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 122.0078 250.54)",
    className: "st1 st2 st4"
  }, "Max Size: pvalue &lt; 0.05, log2FC = 8.4"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 63.7,
    cy: 142.9,
    r: 10
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -189.9972,
    y1: 78.1475,
    x2: -188.9972,
    y2: 78.1475,
    gradientTransform: "matrix(200 0 0 20 38103.2227 -1519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5169B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED69B4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.9,34h180c5.5,0,10,4.5,10,10l0,0c0,5.5-4.5,10-8,10h-180c-7.5,0-12-4.5-12-10l0,0 C102.9,38.4,107.4,34,112.9,34z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 105.7178 23.95)",
    className: "st1 st2 st3"
  }, "LinkColor by alnTMscore")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 92.6078 73.95)",
    className: "st1 st2 st4"
  }, "0.9")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 292.6078 73.95)",
    className: "st1 st2 st4"
  }, "1.0")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottom);
export default __webpack_public_path__ + "static/media/right-bottom.1fb82f4e0e8df13a5e13ceb3e3fccf7f.svg";
export { ForwardRef as ReactComponent };